import AlertIcon from '@/CustomIcons/AlertIcon'
import { cn } from '@/utlis/cn'

type AlertProps = {
    className?: string
    contentClassName?: string
    variant: 'solid' | 'outlined'
    level: 'success' | 'danger' | 'warning'
    children?: React.ReactNode
}

export function Alert(props: AlertProps) {
    if (props.variant === 'solid') {
        return <SolidAlert {...props} />
    } else {
        return <OutlinedAlert {...props} />
    }
}

function OutlinedAlert(props: AlertProps) {
    const bg = {
        'bg-[radial-gradient(50px_30px_at_25px_90%,rgba(133,224,163,0.1)_0%,rgba(133,224,163,0.05)_30%,rgba(255,255,255,0)_100%)]':
            props.level === 'success',
        'bg-[radial-gradient(50px_30px_at_25px_90%,rgba(252,221,64,0.1)_0%,rgba(252,221,64,0.05)_30%,rgba(255,255,255,0)_100%)]':
            props.level === 'warning',
        'bg-[radial-gradient(50px_30px_at_25px_90%,rgba(252,80,80,0.1)_0%,rgba(252,80,80,0.05)_30%,rgba(255,255,255,0)_100%)]':
            props.level === 'danger',
    }
    const iconColor = {
        'text-muse-warning': props.level === 'warning',
        'text-muse-danger': props.level === 'danger',
        'text-muse-success': props.level === 'success',
    }

    return (
        <div
            className={cn(
                'rounded-[16px] p-[8px] flex items-center gap-[8px] bg-[#2a2a2a] border-muse-toplit',
                bg,
                props.className
            )}
        >
            <AlertIcon className={cn('w-[24px] h-[24px]', iconColor)} />
            <div>{props.children}</div>
        </div>
    )
}

function SolidAlert(props: AlertProps) {
    const bg = {
        'bg-muse-success': props.level === 'success',
        'bg-muse-danger': props.level === 'danger',
        'bg-muse-primary-gradient': props.level === 'warning',
    }
    return (
        <div className={cn('text-black rounded-[16px] p-[8px] flex items-center gap-[8px]', bg, props.className)}>
            <AlertIcon className="w-[24px] h-[24px]" />
            <div className={props.contentClassName}>{props.children}</div>
        </div>
    )
}
